import { Product } from '../types';

// ============================================
// BATTERY ACCESSORIES
// ============================================

// PVC INSULATION TAPE
export const insulationTapeProducts: Product[] = [
  {
    id: "tape-1",
    name: "PVC Insulation Tape",
    slug: "pvc-insulation-tape",
    category: "Insulation Materials",
    subcategory: "Electrical Tape",
    description: "Premium quality PVC insulation tape for electrical insulation and bundling. Excellent adhesion and durability.",
    featured: true,
    specifications: {
      "Nominal Width": "16mm",
      "Nominal Length": "15 Meters",
      "Nominal Thickness": "0.12mm",
      "Material": "PVC",
      "Color": "Multiple colors available",
    },
    tags: ["tape", "insulation", "pvc", "electrical"],
    applications: ["Electrical Insulation", "Wire Bundling", "Automotive"],
  },
];

// BATTERY CABLE SETS
export const batteryCableSetProducts: Product[] = [
  // Battery Cable Fitting / Battery Jointer Both Side Terminal
  {
    id: "bcs-fitting-1",
    name: "Battery Cable Fitting (Battery Jointer Both Side Terminal)",
    slug: "battery-cable-fitting",
    category: "Battery Accessories",
    subcategory: "Cable Fittings",
    description: "Battery cable fittings with terminals on both sides. Available in 12\", 18\", 24\", 30\", 36\", and 42\" lengths.",
    featured: true,
    variantType: "size",
    defaultVariant: "bcf-12",
    variants: [
      {
        id: "bcf-12",
        code: "SBC0012BT",
        name: "12\" (305mm)",
        specifications: {
          "Length": "12\" (305mm)",
          "Type": "Battery Jointer Both Side Terminal",
          "Application": "Battery connections",
        },
      },
      {
        id: "bcf-18",
        code: "SBC0018BT",
        name: "18\" (458mm)",
        specifications: {
          "Length": "18\" (458mm)",
          "Type": "Battery Jointer Both Side Terminal",
          "Application": "Battery connections",
        },
      },
      {
        id: "bcf-24",
        code: "SBC0024BT",
        name: "24\" (610mm)",
        specifications: {
          "Length": "24\" (610mm)",
          "Type": "Battery Jointer Both Side Terminal",
          "Application": "Battery connections",
        },
      },
      {
        id: "bcf-30",
        code: "SBC0030BT",
        name: "30\" (762mm)",
        specifications: {
          "Length": "30\" (762mm)",
          "Type": "Battery Jointer Both Side Terminal",
          "Application": "Battery connections",
        },
      },
      {
        id: "bcf-36",
        code: "SBC0036BT",
        name: "36\" (915mm)",
        specifications: {
          "Length": "36\" (915mm)",
          "Type": "Battery Jointer Both Side Terminal",
          "Application": "Battery connections",
        },
      },
      {
        id: "bcf-42",
        code: "SBC0042BT",
        name: "42\" (1067mm)",
        specifications: {
          "Length": "42\" (1067mm)",
          "Type": "Battery Jointer Both Side Terminal",
          "Application": "Battery connections",
        },
      },
    ],
    specifications: {
      "Type": "Battery Jointer Both Side Terminal",
      "Available Lengths": "12\", 18\", 24\", 30\", 36\", 42\"",
      "Packing": "10 Pcs per pack",
    },
    tags: ["battery", "cable", "fitting", "terminal"],
    applications: ["Battery Connections", "Automotive"],
  },
  // Battery Terminal Jointer
  {
    id: "bcs-jointer-1",
    name: "Battery Terminal Jointer",
    slug: "battery-terminal-jointer",
    category: "Battery Accessories",
    subcategory: "Terminal Joiners",
    description: "Battery terminal jointer for extending battery cables. Available in multiple lengths.",
    variantType: "size",
    defaultVariant: "btj-12",
    variants: [
      {
        id: "btj-12",
        code: "STC0012TL",
        name: "12\" (305mm)",
        specifications: {
          "Length": "12\" (305mm)",
          "Type": "Terminal Jointer",
        },
      },
      {
        id: "btj-18",
        code: "STC0018TL",
        name: "18\" (458mm)",
        specifications: {
          "Length": "18\" (458mm)",
          "Type": "Terminal Jointer",
        },
      },
      {
        id: "btj-24",
        code: "STC0024TL",
        name: "24\" (610mm)",
        specifications: {
          "Length": "24\" (610mm)",
          "Type": "Terminal Jointer",
        },
      },
      {
        id: "btj-30",
        code: "STC0030TL",
        name: "30\" (762mm)",
        specifications: {
          "Length": "30\" (762mm)",
          "Type": "Terminal Jointer",
        },
      },
      {
        id: "btj-36",
        code: "STC0036TL",
        name: "36\" (915mm)",
        specifications: {
          "Length": "36\" (915mm)",
          "Type": "Terminal Jointer",
        },
      },
      {
        id: "btj-42",
        code: "STC0042TL",
        name: "42\" (1067mm)",
        specifications: {
          "Length": "42\" (1067mm)",
          "Type": "Terminal Jointer",
        },
      },
    ],
    specifications: {
      "Type": "Terminal Jointer",
      "Available Lengths": "12\", 18\", 24\", 30\", 36\", 42\"",
      "Packing": "10 Pcs per pack",
    },
    tags: ["battery", "terminal", "jointer"],
    applications: ["Battery Connections", "Cable Extension"],
  },
  // Maruti Car Cable Set
  {
    id: "bcs-maruti-car",
    name: "Maruti Car Battery Cable Set",
    slug: "maruti-car-cable-set",
    category: "Battery Accessories",
    subcategory: "Vehicle Specific",
    description: "Battery cable set for Maruti cars with negative and positive terminals. Available in multiple lengths.",
    featured: true,
    variantType: "size",
    defaultVariant: "mcs-12",
    variants: [
      {
        id: "mcs-12",
        code: "SBC0012DL",
        name: "12\" (305mm)",
        specifications: {
          "Length": "12\" (305mm)",
          "Compatible": "Maruti Car",
          "Type": "Negative & Positive",
        },
      },
      {
        id: "mcs-18",
        code: "SBC0018DL",
        name: "18\" (458mm)",
        specifications: {
          "Length": "18\" (458mm)",
          "Compatible": "Maruti Car",
          "Type": "Negative & Positive",
        },
      },
      {
        id: "mcs-24",
        code: "SBC0024DL",
        name: "24\" (610mm)",
        specifications: {
          "Length": "24\" (610mm)",
          "Compatible": "Maruti Car",
          "Type": "Negative & Positive",
        },
      },
      {
        id: "mcs-30",
        code: "SBC0030DL",
        name: "30\" (762mm)",
        specifications: {
          "Length": "30\" (762mm)",
          "Compatible": "Maruti Car",
          "Type": "Negative & Positive",
        },
      },
      {
        id: "mcs-36",
        code: "SBC0036DL",
        name: "36\" (915mm)",
        specifications: {
          "Length": "36\" (915mm)",
          "Compatible": "Maruti Car",
          "Type": "Negative & Positive",
        },
      },
      {
        id: "mcs-42",
        code: "SBC0042DL",
        name: "42\" (1067mm)",
        specifications: {
          "Length": "42\" (1067mm)",
          "Compatible": "Maruti Car",
          "Type": "Negative & Positive",
        },
      },
    ],
    specifications: {
      "Compatible": "Maruti Car",
      "Type": "Negative & Positive",
      "Available Lengths": "12\", 18\", 24\", 30\", 36\", 42\"",
      "Packing": "10 Pcs per pack",
    },
    tags: ["battery", "cable", "maruti", "car"],
    applications: ["Maruti Cars", "Battery Connections"],
  },
  // Maruti Van Cable Set
  {
    id: "bcs-maruti-van",
    name: "Maruti Van Battery Cable Set",
    slug: "maruti-van-cable-set",
    category: "Battery Accessories",
    subcategory: "Vehicle Specific",
    description: "Battery cable set for Maruti vans with negative and positive terminals.",
    partNumber: "SBC000021",
    specifications: {
      "Compatible": "Maruti Van",
      "Type": "Negative & Positive",
      "Packing": "10 Pcs per pack",
    },
    tags: ["battery", "cable", "maruti", "van"],
    applications: ["Maruti Van", "Battery Connections"],
  },
  // North America / Earth Moving Vehicle
  {
    id: "bcs-na-1",
    name: "Battery Cable Set for North America (Positive on Right)",
    slug: "battery-cable-north-america",
    category: "Battery Accessories",
    subcategory: "Regional Specific",
    description: "Battery cable set for North American vehicles with positive terminal on the right side.",
    partNumber: "SBC000031",
    specifications: {
      "Type": "Positive (+) on Right",
      "Region": "North America",
      "Packing": "12 Pcs per pack",
    },
    tags: ["battery", "cable", "north-america"],
    applications: ["North American Vehicles"],
  },
  {
    id: "bcs-em-1",
    name: "Battery Cable Set for Earth Moving Vehicle",
    slug: "battery-cable-earth-moving",
    category: "Battery Accessories",
    subcategory: "Heavy Duty",
    description: "Heavy-duty battery cable set for earth moving equipment and machinery.",
    partNumber: "SBC000032",
    image: "/products/battery-accessories/cable-sets/SBC000032.jpg",
    featured: true,
    specifications: {
      "Type": "Heavy Duty",
      "Application": "Earth Moving Vehicles",
      "Packing": "1 Set",
    },
    tags: ["battery", "cable", "earth-moving", "heavy-duty"],
    applications: ["Earth Moving Equipment", "Heavy Machinery"],
  },
  {
    id: "bcs-seva",
    name: "Battery Cable Set for Seva Type",
    slug: "battery-cable-seva-type",
    category: "Battery Accessories",
    subcategory: "Vehicle Specific",
    description: "Battery cable set for Seva type vehicles.",
    partNumber: "SBC000042",
    image: "/products/battery-accessories/cable-sets/SBC000042.jpg",
    specifications: {
      "Compatible": "Seva Type",
      "Type": "Custom configuration",
      "Packing": "1 Set",
    },
    tags: ["battery", "cable", "seva"],
    applications: ["Seva Type Vehicles"],
  },
];

// JUMPER CABLE SETS
export const jumperCableProducts: Product[] = [
  {
    id: "jc-1",
    name: "Jumper Cable Set - 1.8M",
    slug: "jumper-cable-1.8m",
    category: "Battery Accessories",
    subcategory: "Jumper Cables",
    description: "Heavy-duty jumper cable set for emergency battery jump-starting. 1.8 meters (1800mm) length.",
    partNumber: "SBC000031",
    specifications: {
      "Length": "1.8 Meter (1800mm)",
      "Type": "Jumper Cable Set",
      "Packing": "1 Set",
    },
    tags: ["jumper", "cable", "emergency"],
    applications: ["Emergency Jump Start", "Battery Boost"],
  },
  {
    id: "jc-2",
    name: "Jumper Cable Set - 2.5M",
    slug: "jumper-cable-2.5m",
    category: "Battery Accessories",
    subcategory: "Jumper Cables",
    description: "Heavy-duty jumper cable set. 2.5 meters (2500mm) length.",
    partNumber: "SBC000034",
    featured: true,
    specifications: {
      "Length": "2.5 Meter (2500mm)",
      "Type": "Jumper Cable Set",
      "Packing": "1 Set",
    },
    tags: ["jumper", "cable", "emergency"],
    applications: ["Emergency Jump Start", "Battery Boost"],
  },
  {
    id: "jc-3",
    name: "Jumper Cable Set - 3M",
    slug: "jumper-cable-3m",
    category: "Battery Accessories",
    subcategory: "Jumper Cables",
    description: "Heavy-duty jumper cable set. 3 meters (3000mm) length.",
    partNumber: "SBC000036",
    image: "/products/battery-accessories/cable-sets/SBC000036.jpg",
    specifications: {
      "Length": "3 Meter (3000mm)",
      "Type": "Jumper Cable Set",
      "Packing": "1 Set",
    },
    tags: ["jumper", "cable", "emergency"],
    applications: ["Emergency Jump Start", "Battery Boost"],
  },
  {
    id: "jc-4",
    name: "Jumper Cable Set - 4M",
    slug: "jumper-cable-4m",
    category: "Battery Accessories",
    subcategory: "Jumper Cables",
    description: "Heavy-duty jumper cable set. 4 meters (4000mm) length.",
    partNumber: "SBC000042",
    image: "/products/battery-accessories/cable-sets/SBC000042.jpg",
    specifications: {
      "Length": "4 Meter (4000mm)",
      "Type": "Jumper Cable Set",
      "Packing": "1 Set",
    },
    tags: ["jumper", "cable", "emergency"],
    applications: ["Emergency Jump Start", "Battery Boost"],
  },
  {
    id: "jc-5",
    name: "Jumper Cable Set - 6M",
    slug: "jumper-cable-6m",
    category: "Battery Accessories",
    subcategory: "Jumper Cables",
    description: "Extra-long heavy-duty jumper cable set. 6 meters (6000mm) length.",
    partNumber: "SBC000038",
    specifications: {
      "Length": "6 Meter (6000mm)",
      "Type": "Jumper Cable Set",
      "Packing": "1 Set",
    },
    tags: ["jumper", "cable", "emergency", "long"],
    applications: ["Emergency Jump Start", "Battery Boost", "Long Distance"],
  },
];

// FLAT EARTHING WIRE
export const earthingWireProducts: Product[] = [
  {
    id: "wire-flat-earthing-wire-2",
    name: "Flat Earthing Wire",
    slug: "flat-earthing-wire-2",
    category: "Battery Accessories",
    subcategory: "Earthing Wires",
    description: "Braided flat earthing wires for grounding applications. Available in various lengths for different installation requirements.",
    images: ["/products/wire-cables/battery-cable-set/flat-earthing-wire.jpg"],
    variantType: "size",
    defaultVariant: "few-roll",
    variants: [
      {
        id: "few-roll",
        code: "SEW000001",
        name: "Roll (7.5 Meter)",
        specifications: {
          "Part Number": "SEW000001",
          "Size": "Roll",
          "Length": "7.5 Meter",
          "Standard Packing": "12 Pcs. Packing",
        },
      },
      {
        id: "few-12",
        code: "SEW000012",
        name: "12\" (305mm)",
        specifications: {
          "Part Number": "SEW000012",
          "Size": "12\"",
          "Length": "305mm",
          "Standard Packing": "12 Pcs. Packing",
        },
      },
      {
        id: "few-15",
        code: "SEW000015",
        name: "15\" (381mm)",
        specifications: {
          "Part Number": "SEW000015",
          "Size": "15\"",
          "Length": "381mm",
          "Standard Packing": "12 Pcs. Packing",
        },
      },
      {
        id: "few-18",
        code: "SEW000018",
        name: "18\" (458mm)",
        specifications: {
          "Part Number": "SEW000018",
          "Size": "18\"",
          "Length": "458mm",
          "Standard Packing": "12 Pcs. Packing",
        },
      },
      {
        id: "few-24",
        code: "SEW000024",
        name: "24\" (610mm)",
        specifications: {
          "Part Number": "SEW000024",
          "Size": "24\"",
          "Length": "610mm",
          "Standard Packing": "12 Pcs. Packing",
        },
      },
    ],
    specifications: {
      "Type": "Flat Earthing Wire",
      "Material": "Braided Metallic Strip",
      "Standard Packing": "12 Pcs. Packing",
    },
    tags: ["earthing", "wire", "grounding", "flat", "braided"],
    applications: ["Automotive", "Grounding", "Electrical Safety"],
  },
];

// CHARGING CLIPS
export const chargingClipProducts: Product[] = [
  {
    id: "cc-scc000001",
    name: "Export Big (Brass) - SCC000001",
    slug: "export-big-brass-scc000001",
    category: "Battery Accessories",
    subcategory: "Charging Clips",
    description: "Export Big charging clip in brass. Heavy-duty battery clamps with red and black ribbed plastic handles. High conductivity and corrosion resistance.",
    partNumber: "SCC000001",
    images: ["/products/battery-accessories/charging-clips/SCC000001.jpg"],
    featured: true,
    specifications: {
      "Material": "Brass",
      "Type": "Export Big",
      "Finish": "Natural Brass",
      "Features": "Ribbed plastic handles (Red & Black)",
      "Quality": "Export Grade",
    },
    tags: ["charging", "clip", "brass", "battery", "export", "big"],
    applications: ["Battery Charging", "Jump Starting", "Heavy Duty"],
  },
  {
    id: "cc-scc000011",
    name: "Export Big (Iron) - SCC000011",
    slug: "export-big-iron-scc000011",
    category: "Battery Accessories",
    subcategory: "Charging Clips",
    description: "Export Big charging clip in iron. Heavy-duty battery clamps with red and black ribbed plastic handles. Cost-effective solution for battery charging applications.",
    partNumber: "SCC000011",
    images: ["/products/battery-accessories/charging-clips/SCC000011.jpg"],
    specifications: {
      "Material": "Iron",
      "Type": "Export Big",
      "Finish": "Natural Iron",
      "Features": "Ribbed plastic handles (Red & Black)",
      "Quality": "Export Grade",
    },
    tags: ["charging", "clip", "iron", "battery", "export", "big"],
    applications: ["Battery Charging", "Jump Starting", "Economy Applications"],
  },
  {
    id: "cc-scc000015",
    name: "Export Big (Zinc White) - SCC000015",
    slug: "export-big-zinc-white-scc000015",
    category: "Battery Accessories",
    subcategory: "Charging Clips",
    description: "Export Big charging clip with zinc white plating. Heavy-duty battery clamps with red and black ribbed plastic handles. Excellent corrosion resistance.",
    partNumber: "SCC000015",
    images: ["/products/battery-accessories/charging-clips/SCC000015.jpg"],
    specifications: {
      "Material": "Zinc Plated",
      "Type": "Export Big",
      "Finish": "Zinc White",
      "Features": "Ribbed plastic handles (Red & Black)",
      "Quality": "Export Grade",
    },
    tags: ["charging", "clip", "zinc", "white", "battery", "export", "big"],
    applications: ["Battery Charging", "Jump Starting", "Corrosion Resistant Applications"],
  },
  {
    id: "cc-scc000017",
    name: "Export Big (Zing Golden) - SCC000017",
    slug: "export-big-zing-golden-scc000017",
    category: "Battery Accessories",
    subcategory: "Charging Clips",
    description: "Export Big charging clip with Zing Golden finish. Heavy-duty battery clamps with red and black ribbed plastic handles. Premium appearance with excellent conductivity.",
    partNumber: "SCC000017",
    images: ["/products/battery-accessories/charging-clips/SCC000017.jpg"],
    featured: true,
    specifications: {
      "Material": "Zinc Plated",
      "Type": "Export Big",
      "Finish": "Zing Golden",
      "Features": "Ribbed plastic handles (Red & Black)",
      "Quality": "Export Grade",
    },
    tags: ["charging", "clip", "zinc", "golden", "zing", "battery", "export", "big"],
    applications: ["Battery Charging", "Jump Starting", "Premium Applications"],
  },
  {
    id: "cc-scc000040",
    name: "Crocodile Clip (Brass) - SCC000040",
    slug: "crocodile-clip-brass-scc000040",
    category: "Battery Accessories",
    subcategory: "Charging Clips",
    description: "Crocodile clip with brass construction. Compact design with strong spring-loaded jaws for secure connection. No plastic handles, bare metal construction.",
    partNumber: "SCC000040",
    images: ["/products/battery-accessories/charging-clips/SCC000040.jpg"],
    specifications: {
      "Material": "Brass",
      "Type": "Crocodile Clip",
      "Feature": "Spring-loaded jaws",
      "Design": "Compact, bare metal",
    },
    tags: ["crocodile", "clip", "brass", "battery"],
    applications: ["Battery Charging", "Electrical Testing", "General Purpose"],
  },
];
